export default __webpack_public_path__ + "static/media/DAIF_Eco_Screen2_in-end.71535ecb.jpg";